(function() {
	'use strict';

	/* 
	* Usage example:
	*
	* {{ am.wakeHistoryBlockStart('', 'div', 'ng-controller="WakeHistoryController" ng-show="show(\'seller-county\')"') }}
    * 	<cta-banner extra-padding="50px" timeout="1000"></cta-banner>
	* {{ am.wakeHistoryBlockEnd() }}
	*
	*/

	function ctaBanner() {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: 'cta-banner.html',
			scope: {
				city: '@',
				extraPadding: '@',
				timeout: '@',
				ctrlFn: '&',
				visible: '=',
				textOverride: '@?'
			},
			link: function(scope, element, attrs) {
				var nextElementSibling, animationInterval;

				if (!scope.city || !scope.visible) {
					element[0].classList.add('ng-hide');
					return;
				}

				document.body.classList.add('has-cta');

				setTimeout(function() {
					element[0].classList.add('animate');
					element[0].classList.add('animate-in');

				}, scope.timeout && !isNaN(scope.timeout) ? scope.timeout : 2000);

				if (scope.extraPadding) {
					nextElementSibling = element[0].parentNode.nextElementSibling || null;

					if (nextElementSibling) {
						var nextElementStyle = window.getComputedStyle(nextElementSibling, null),
							nextElementPadding = nextElementStyle["paddingTop"] || 0;

						nextElementSibling.style.paddingTop = "calc(" + nextElementPadding + " + " + scope.extraPadding + ")";
					}
				}

				scope.dismissBanner = function() {
					element[0].classList.add('animate-out');

					if (animationInterval) {
						clearInterval(animationInterval);
					}

					setTimeout(function() {
						element[0].parentNode.removeChild(element[0]);

						if (nextElementSibling) {
							nextElementSibling.style.paddingTop = nextElementPadding;
						}

						document.body.classList.remove('has-cta');

						scope.ctrlFn();
					}, 1000);
				};
			}
		};
	}

	angular.module('KimaMain').directive('ctaBanner', ctaBanner);
})();